import React from "react";

const AddressContext = React.createContext();
const Web3StateContext = React.createContext();
const SocialLoginSDKContext = React.createContext();
const gSignerContext = React.createContext();

export {
  AddressContext,
  Web3StateContext,
  SocialLoginSDKContext,
  gSignerContext,
};
